import {
  FORGET_PASSWORD_INIT,
  FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD_SUCCESS,
} from "./constants";

const initialState = {
  loading: false,
  success : false
};

export default function forgetPassword(state = initialState, action) {
  switch (action.type) {
    case FORGET_PASSWORD_INIT:
      return { ...state, loading: true };
    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.data.success
      };
    case FORGET_PASSWORD_FAILED:
      return { ...state, loading: false };

    default:
      return state;
  }
}
